import { FC, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AxiosResponse, AxiosError } from 'axios';
import { axiosInstance } from 'shared/services/Http.service';
import { createAction } from 'shared/util/Utility';
import { IResponseObject } from 'shared/interface';
import Notification, { notify } from 'shared/components/notification/notification';
import * as actionTypes from 'store/action-types';
const ErrorHandler: FC = () => {
	const dispatch = useDispatch();
	const logout = useCallback(() => {
		dispatch(createAction(actionTypes.AUTH_FAIL));
	}, [dispatch]);

	const handleSuccessResponse = (res: AxiosResponse<IResponseObject<any>>) => {
		const data = res.data;
		if (data && data.message && res.config?.method !== 'get') {
			notify(data.message, 'success');
		}
		return res;
	};
	const handleErrorResponse = useCallback(
		(error: AxiosError<IResponseObject<any>>) => {
			const res = error.response;
			if (res && res.data && res.status) {
				const status = res.status;
				const responseData = res.data;
				if ((status === 401 || status === 403) && responseData) {
					logout();
				}
				notify(responseData.message, 'error');
				throw error;
			}
		},
		[logout]
	);

	useEffect(() => {
		const resInterceptor = axiosInstance.interceptors.response.use(handleSuccessResponse, handleErrorResponse);
		return () => axiosInstance.interceptors.response.eject(resInterceptor);
	}, [handleErrorResponse]);
	return <Notification />;
};
export default ErrorHandler;
